import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation.ts';

const partnerNames = [
  'Hilti',
  'DeWalt',
  '3M Safety',
  'Bosch',
  'Milwaukee Tool',
  'Caterpillar',
  'FallTech',
  'Makita',
];

const TechStack: React.FC = () => {
    const { ref, isVisible } = useScrollAnimation<HTMLDivElement>();
    const allPartners = [...partnerNames, ...partnerNames];

  return (
    <section id="techstack" ref={ref} className="py-24 bg-gray-100 dark:bg-black/20 overflow-hidden">
      <div className={`container mx-auto px-6 scroll-animation ${isVisible ? 'visible' : ''}`}>
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Manage Any Asset, From Any Manufacturer</h2>
          <p className="text-gray-700 dark:text-gray-400">
            Shield is brand-agnostic. Track, inspect, and manage all your critical assets in one place, from power tools and PPE to heavy machinery and vehicles.
          </p>
        </div>
        <div className="relative w-full [mask-image:linear-gradient(to_right,transparent,white_10%,white_90%,transparent)]">
            <div className="marquee-container flex w-max">
                <div className="marquee-content flex animate-marquee-left items-center">
                    {allPartners.map((name, index) => (
                        <div 
                        key={index} 
                        className="flex-shrink-0 bg-gray-200/70 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-800 dark:text-gray-300 font-medium px-6 py-3 rounded-lg text-center mx-4 transition-all duration-300 hover:bg-orange-100 dark:hover:bg-orange-500/10 hover:border-orange-500 dark:hover:border-[#FF4D00]/50 hover:text-orange-600 dark:hover:text-[#FF4D00] transform hover:scale-105 shadow-lg shadow-orange-600/10 hover:shadow-2xl hover:shadow-orange-600/20 dark:shadow-lg dark:shadow-black/20 dark:hover:shadow-2xl dark:hover:shadow-[#FF4D00]/20"
                        >
                        {name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;